// Shared constants and real Pulaar content
export const NAV_LEFT = [
  { label: "Archives", path: "/archives" },
];
export const NAV_RIGHT = [
  { label: "Vestiaire", path: "/vestiaire" },
  { label: "Contact", path: "/contact" },
];
export const NAV_ITEMS = [...NAV_LEFT, ...NAV_RIGHT];

// Brand assets
export const BRAND_LOGO_KU = "/brand/pulaar-logo-ku-monogramme.png";
export const INSTAGRAM_URL = "https://instagram.com/pulaar.co";
export const INSTAGRAM_HANDLE = "@pulaar.co";

export const HERO_IMAGE = "/heritage/pulaar-argentique-fleuve-senegal-bateau.jpg";
export const HERO_SECONDARY = [
  "/heritage/dammeel/pulaar-dammeel-gallery-28.jpg",
  "/heritage/ceddo/pulaar-ceddo-gallery-15.jpg",
];

// Univers — narrative chapters (NOT commercial collections)
export const MONDES = [
  {
    slug: "maabube",
    name: "Maabube",
    subtitle: "La main qui transmet.",
    teaser:
      "Le Maabo préserve les savoirs par la main. Son art transmet une mémoire vivante : celle du geste, du tissage et de la matière qui traverse le temps.",
    symbol: "I",
    cover: "/heritage/maabube/pulaar-maabube-cover.jpg",
    archiveCover: "/heritage/maabube/pulaar-maabube-gallery-06.jpg",
    heroImage: "/heritage/maabube/pulaar-maabube-archivecover.jpg",
    quote:
      "Le marteau du Maabube frappe avec sagesse, car chaque coup scelle l’histoire et façonne l’avenir.",
    quotePulaar:
      "Gollek Maabo ɗeɗon moɗɗi, ko e hoore ngam wondi ngal ɓoyde ngol e kala amar.",
    storyTitle: "Le Maître Tisserand : Demba Maabu",
    story: [
      "Dans les terres du Fouta, vivait Demba Maabu, un tisserand aux mains magiques. Les Maabube étaient des artisans sacrés, et leurs étoffes portaient des histoires tissées dans les fils.",
      "Demba répondit au roi : « Donnez-moi le temps, et je vous offrirai un tissu qui parle. » Pendant des mois, il travailla en silence, parlant aux esprits et écoutant le murmure des ancêtres.",
      "Quand l’étoffe fut terminée, elle brillait comme l’or et portait les motifs d’un peuple. « Mon art n’est pas à vendre. Il vient de mes ancêtres, et c’est pour eux que je tisse », dit-il.",
      "Les Maabube nous montrent que l’artisanat est l’âme d’une civilisation.",
    ],
    credit: {
      photo: "Bradley Ogbonna",
      photoUrl: "https://www.instagram.com/bradogbonna/",
      da: "Bachir Mbaye",
      daUrl: "https://www.instagram.com/bachirmbaye/",
    },
    gallery: [
      "/heritage/maabube/pulaar-maabube-gallery-01.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-02.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-03.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-04.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-05.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-06.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-07.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-08.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-09.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-10.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-11.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-12.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-13.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-14.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-15.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-16.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-17.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-18.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-19.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-20.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-21.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-22.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-23.jpg",
      "/heritage/maabube/pulaar-maabube-gallery-24.jpg",
    ],
  },
  {
    slug: "dammeel",
    name: "Dammeel",
    subtitle: "L’allure comme héritage.",
    teaser:
      "Dammeel évoque une noblesse sans démonstration. Une présence, une tenue, une manière d’entrer dans l’espace. Le vêtement devient calme, autorité et élégance silencieuse.",
    symbol: "II",
    cover: "/heritage/dammeel/pulaar-dammeel-gallery-28.jpg",
    archiveCover: "/heritage/dammeel/pulaar-dammeel-gallery-14.jpg",
    heroImage: "/heritage/dammeel/pulaar-dammeel-gallery-23.jpg",
    quote:
      "Un chef digne n’est pas seulement couronné, il porte le poids et la sagesse de son peuple.",
    quotePulaar: "Dammeel mo wonaa dowri kala, njaari e dabbunde maɓɓe nde heewi.",
    storyTitle: "Le Roi Humble : Kumba Ndoffène Mbodj",
    story: [
      "Au cœur du Kajoor, un Dammeel nommé Kumba Ndoffène Mbodj aimait son peuple plus que tout. Plutôt que de rester dans son palais, il parcourait les villages déguisé en simple voyageur.",
      "Un fermier dit : « Comment le roi peut-il comprendre nos souffrances, lui qui ne connaît pas la sueur du travail ? » Touché, Kumba retourna dans les champs et passa la journée à labourer sous le soleil brûlant.",
      "Quand il révéla son identité, le fermier tomba à genoux. « Un bon roi doit ressentir les souffrances de son peuple pour le servir avec justice », dit-il.",
      "Les Dammeel nous rappellent que la vraie grandeur d’un roi est son humilité.",
    ],
    credit: {
      photo: "Jules Renault",
      photoUrl: "https://www.instagram.com/renaultjules/",
      da: "Bachir Mbaye",
      daUrl: "https://www.instagram.com/bachirmbaye/",
    },
    gallery: [
      "/heritage/dammeel/pulaar-dammeel-gallery-01.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-02.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-03.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-04.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-05.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-06.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-07.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-08.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-09.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-10.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-11.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-12.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-13.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-14.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-15.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-16.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-17.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-18.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-19.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-20.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-21.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-22.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-23.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-24.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-25.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-26.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-27.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-28.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-29.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-30.jpg",
      "/heritage/dammeel/pulaar-dammeel-gallery-31.jpg",
    ],
  },
  {
    slug: "ceddo",
    name: "Ceddo",
    subtitle: "Le corps debout.",
    teaser:
      "Ceddo porte l’idée de résistance, de protection et de mouvement. Ce chapitre explore des silhouettes plus franches : vêtements de passage, de route, de mémoire et de tenue intérieure.",
    symbol: "III",
    cover: "/heritage/ceddo/pulaar-ceddo-gallery-15.jpg",
    archiveCover: "/heritage/ceddo/pulaar-ceddo-gallery-02.jpg",
    heroImage: "/heritage/ceddo/pulaar-ceddo-gallery-08.jpg",
    quote:
      "Le Ceddo tient sa lance avec fierté, mais c’est le courage qui donne le véritable poids à son arme.",
    quotePulaar: "Ceddo moɗɗo ɓurtaare, woodani ko nduuɗi ɗi heɓi hayre.",
    storyTitle: "Le Guerrier et son Destin : Mbañik Ndongo",
    story: [
      "Dans le royaume du Kajoor, un jeune Ceddo nommé Mbañik Ndongo était connu pour son courage et son sens de l’honneur. Mais Mbañik était différent : il n’était pas seulement fort, il avait l’esprit d’un stratège.",
      "Quand une armée ennemie menaça le royaume, il se leva : « Donnez-moi vos hommes, et je protégerai notre terre comme un lion protège sa tanière. » Avec une poignée de guerriers, il vainquit l’ennemi par la ruse.",
      "Quand le Dammeel mourut sans héritier, les sages dirent : « Cet homme, bien qu’il ne soit pas noble, a le cœur d’un roi. » Mbañik devint Damel, le premier Tiedo à porter la couronne.",
      "Les Ceddo nous enseignent le courage et le sacrifice.",
    ],
    credit: {
      photo: "Nico Bustos",
      photoUrl: "https://www.instagram.com/nicobustos/",
      da: "Bachir Mbaye",
      daUrl: "https://www.instagram.com/bachirmbaye/",
    },
    gallery: [
      "/heritage/ceddo/pulaar-ceddo-gallery-01.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-02.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-03.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-04.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-05.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-06.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-07.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-08.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-09.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-10.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-11.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-12.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-13.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-14.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-15.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-16.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-17.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-18.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-19.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-20.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-21.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-22.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-23.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-24.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-25.jpg",
      "/heritage/ceddo/pulaar-ceddo-gallery-26.jpg",
    ],
  },
];

export const MONDE_BY_SLUG = Object.fromEntries(MONDES.map((m) => [m.slug, m]));

// Vestiaire categories — 5 catégories
export const CATEGORIES = [
  { slug: "tous", label: "Tous" },
  { slug: "tops", label: "Tops" },
  { slug: "chemises", label: "Chemises" },
  { slug: "vestes", label: "Vestes" },
  { slug: "pantalons", label: "Pantalons" },
];

// status: 'available' | 'soon'
// 9 modèles — taille unique
export const PRODUCTS = [
  // ── TOPS ──────────────────────────────────────────────────────────────
  {
    slug: "tunique-maabo",
    name: "Tunique Maabo",
    category: "tops",
    price: 390,
    status: "soon",
    short:
      "Tunique fluide à liserés brodés — pièce d’apparat à porter sur pantalon ou seule, longueur mi-cuisse.",
    matiere:
      "Coton tissé fin écru, bandes brodées de fil de soie noir, doublure intérieure non collée.",
    origine: "Sénégal · Mali · France.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Encolure ronde finie main, manches longues à poignet ouvert, fines bandes brodées au col, sur la poitrine, au bas des manches et à l’ourlet. Taille unique.",
    histoire:
      "Inspirée des grands boubous de cérémonie portés au sortir des baptêmes peuls, cette tunique reprend le geste du liseré brodé — fil de soie noir cousu à la main sur coton clair. Une pièce qui se porte droite, comme on entre dans une pièce sans hâte.",
    image: "/products/pulaar-tunique-maabo-front.png",
    gallery: [
      "/products/pulaar-tunique-maabo-front.png",
      "/products/pulaar-tunique-maabo-side.png",
      "/products/pulaar-tunique-maabo-back.png",
      "/products/pulaar-tunique-maabo-detail.png",
    ],
  },
  {
    slug: "top-raye-ceddo",
    name: "Top Rayé Ceddo",
    category: "tops",
    price: 320,
    status: "soon",
    short:
      "Top rayé en coton lavé, coupe boxy, rayures contrastées tissées dans la masse — esprit cavalier.",
    matiere:
      "Coton tissé sur métier japonais, rayures noires et écru tissées dans la masse, fils flammés naturels.",
    origine: "France · Japon.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Col rond bord-côte, manches courtes droites, rayures asymétriques entre dos et face, ourlets retournés à la machine plate. Taille unique.",
    histoire:
      "Le rayé du Top Ceddo emprunte sa cadence au mouvement du cheval — ces lignes que l’on voit défiler à la cadence du galop. Un tissu serré, lavé pour adoucir la main, qui garde la rigueur d’une étoffe de travail tout en restant souple sur le corps.",
    image: "/products/pulaar-top-raye-ceddo-front.png",
    gallery: [
      "/products/pulaar-top-raye-ceddo-front.png",
      "/products/pulaar-top-raye-ceddo-front-2.png",
      "/products/pulaar-top-raye-ceddo-back.png",
      "/products/pulaar-top-raye-ceddo-detail.png",
    ],
  },
  {
    slug: "top-patchwork-sahel",
    name: "Top Patchwork Sahel",
    category: "tops",
    price: 450,
    status: "soon",
    short:
      "Top oversize patchwork — bandes ivoire, terre cuite et brique, manches kaki, finitions effilées au bas.",
    matiere:
      "Coton lavé écru, soie sauvage teinte ocre, jacquard de lin brique, manches en sergé olive vieilli — assemblage à plat.",
    origine: "France.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Encolure ronde, coupe boxy oversize, panneaux horizontaux assemblés au point bourdon, ourlets effilochés à la main, manches longues amples. Taille unique.",
    histoire:
      "Le patchwork ne cherche pas l’uniforme — il rassemble. Quatre matières aux mémoires différentes (un coton, une soie, un lin, un sergé) cousues ensemble pour rappeler que toute beauté tient à ce que l’on choisit d’assembler. Une pièce qui réconcilie les chutes et l’éclat.",
    image: "/products/pulaar-top-patchwork-sahel-front.png",
    gallery: [
      "/products/pulaar-top-patchwork-sahel-front.png",
      "/products/pulaar-top-patchwork-sahel-side.png",
      "/products/pulaar-top-patchwork-sahel-back.png",
      "/products/pulaar-top-patchwork-sahel-detail.png",
    ],
  },

  // ── CHEMISES ──────────────────────────────────────────────────────────
  {
    slug: "chemise-cavalier",
    name: "Chemise Cavalier",
    category: "chemises",
    price: 390,
    status: "soon",
    short:
      "Chemise crème nouée à finitions effrangées — silhouette éditoriale, esprit cavalier indocile.",
    matiere:
      "Coton tissé main, lin lavé écru, finitions et ourlets effrangés à la main.",
    origine: "Sénégal · France.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Col chemise classique, fermeture par boutons sous patte cachée, nœud frontal asymétrique, ourlets effilochés au-dessus du genou, manches longues. Taille unique.",
    histoire:
      "Pensée comme la chemise d’un cavalier qui aurait dénoué son col à la fin de la journée. Le nœud n’est pas décoratif : il vient d’un geste ancien, celui qu’on fait quand on se met à l’aise sans pour autant baisser la garde. Une élégance qui s’assouplit.",
    image: "/products/pulaar-chemise-cavalier-front.png",
    gallery: [
      "/products/pulaar-chemise-cavalier-front.png",
      "/products/pulaar-chemise-cavalier-side.png",
      "/products/pulaar-chemise-cavalier-detail.png",
    ],
  },
  {
    slug: "chemise-maabo-florale",
    name: "Chemise Maabo Florale",
    category: "chemises",
    price: 450,
    status: "soon",
    short:
      "Chemise oversize en coton crêpe noir, imprimé floral peul à la main, finitions à plat et boutons en corne.",
    matiere:
      "Coton crêpe noir, impression à la main au tampon de bois (motifs floraux peuls), boutons en corne véritable.",
    origine: "Sénégal · France.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Col chemise classique, double poche poitrine à rabat, manches longues à poignets boutonnés, ourlets retournés, boutons en corne. Taille unique.",
    histoire:
      "Le motif floral noir sur noir vient des tampons de bois utilisés à Saint-Louis pour les pagnes de cérémonie — un imprimé qui disparaît presque à la lumière du jour, qui se révèle seulement au mouvement. Une chemise discrète qui garde sa fierté pour ceux qui regardent vraiment.",
    image: "/products/pulaar-chemise-maabo-florale-front.png",
    gallery: [
      "/products/pulaar-chemise-maabo-florale-front.png",
      "/products/pulaar-chemise-maabo-florale-front-2.png",
      "/products/pulaar-chemise-maabo-florale-back.png",
      "/products/pulaar-chemise-maabo-florale-detail.png",
    ],
  },

  // ── VESTES ────────────────────────────────────────────────────────────
  {
    slug: "surchemise-tisserand-olive",
    name: "Surchemise Tisserand Olive",
    category: "vestes",
    price: 690,
    status: "soon",
    short:
      "Surchemise d’atelier — coton olive imprimé main, poches passepoilées, attaches dorsales, esprit workwear.",
    matiere:
      "Coton sergé olive imprimé main, doublure demi-jersey écrue non thermocollée, boutons en corne.",
    origine: "France.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Deux poches passepoilées à rabat, demi-doublure intérieure, attaches dorsales réglables, boutons en corne, ourlets retournés. Taille unique.",
    histoire:
      "Forme directe d’un vêtement de tisserand : pas de fioriture, deux poches utiles, une attache pour ajuster le dos selon le geste. Le vert olive est obtenu à l’impression manuelle — chaque pièce a sa nuance, jamais tout à fait la même que la voisine.",
    image: "/products/pulaar-surchemise-tisserand-olive-front.png",
    gallery: [
      "/products/pulaar-surchemise-tisserand-olive-front.png",
      "/products/pulaar-surchemise-tisserand-olive-back.png",
    ],
  },
  {
    slug: "veste-patchwork-sahel",
    name: "Veste Patchwork Sahel",
    category: "vestes",
    price: 890,
    status: "soon",
    short:
      "Veste workwear noire à manches tissées en jacquard ancestral — col cuir patiné, poches passepoilées, ourlets effrangés.",
    matiere:
      "Coton denim noir, manches en jacquard peul tissé main, col et finitions en cuir tannage végétal, boutons en corne.",
    origine: "France · Sénégal · Mali.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Col chemise en cuir patiné, deux poches plaquées (une à rabat), patchs intérieurs en tapisserie peule, ourlets effilochés à la main, boutons en corne. Taille unique.",
    histoire:
      "Pièce-pivot du vestiaire : un corps de veste workwear noir auquel on a greffé deux manches en tapisserie peule tissée à la main au Mali. Trois géographies se rencontrent sur un même vêtement — la coupe française, le tissage malien, le cuir patiné par la lumière du Sahel.",
    image: "/products/pulaar-veste-patchwork-sahel-front.png",
    gallery: [
      "/products/pulaar-veste-patchwork-sahel-front.png",
      "/products/pulaar-veste-patchwork-sahel-side.png",
      "/products/pulaar-veste-patchwork-sahel-back.png",
      "/products/pulaar-veste-patchwork-sahel-detail.png",
    ],
  },

  // ── PANTALONS ─────────────────────────────────────────────────────────
  {
    slug: "pantalon-tiedo",
    name: "Pantalon Tiedo",
    category: "pantalons",
    price: 680,
    status: "soon",
    short:
      "Pantalon wide-leg en denim brut indigo, double-boutonnage en taille, laçages d’œillets cuivre sur les côtés.",
    matiere:
      "Denim brut indigo tissé selvedge sur métier japonais, fils flammés écrus, œillets et passants en laiton vieilli.",
    origine: "France · Japon.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Triple boutonnage taille, plis pincés au-devant, laçages cuivre œillet à œillet sur la couture latérale, ceintures denim détachables, finitions à la main. Taille unique.",
    histoire:
      "Né de la rencontre du denim selvedge japonais — réputé pour sa densité et la patine qu’il prend avec le temps — et du laçage cuivre qui structure la cavalerie. Le pantalon vieillira avec celui qui le porte : il prendra ses plis, ses zones d’usure, deviendra un objet personnel.",
    image: "/products/pulaar-pantalon-tiedo-front.png",
    gallery: [
      "/products/pulaar-pantalon-tiedo-front.png",
      "/products/pulaar-pantalon-tiedo-front-2.png",
      "/products/pulaar-pantalon-tiedo-back.png",
      "/products/pulaar-pantalon-tiedo-detail.png",
    ],
  },
  {
    slug: "pantalon-noir-wide",
    name: "Pantalon Noir Wide",
    category: "pantalons",
    price: 520,
    status: "soon",
    short:
      "Pantalon noir ample, ceinture nouée en lien de coton, large jambe — silhouette d’apparat contemporaine.",
    matiere:
      "Coton lavé noir mat, lien de ceinture tressé main, doublure de poches en jersey écru.",
    origine: "Sénégal · France.",
    fabrication: "Atelier Paris — pièce numérotée.",
    details:
      "Ceinture haute fermée par lien de coton tressé à nouer, plis pincés au-devant, large jambe droite, ourlets ouverts sur le dessus du pied, deux poches insérées à la couture. Taille unique.",
    histoire:
      "Pensé comme un pantalon de tenue intérieure — celui qu’on enfile chez soi sans quitter sa dignité. Le lien de ceinture tressé à la main remplace le bouton ; il se noue lentement, comme une cérémonie discrète. La jambe ample retombe droit, sans contrainte.",
    image: "/products/pulaar-pantalon-noir-wide-front.png",
    gallery: [
      "/products/pulaar-pantalon-noir-wide-front.png",
      "/products/pulaar-pantalon-noir-wide-back.png",
      "/products/pulaar-pantalon-noir-wide-detail-1.png",
      "/products/pulaar-pantalon-noir-wide-detail-2.png",
    ],
  },
];

export const PRODUCT_BY_SLUG = Object.fromEntries(PRODUCTS.map((p) => [p.slug, p]));

export const STATUS_LABEL = {
  available: "Disponible",
  soon: "Soon",
};

export const formatPrice = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
